// Port of api/fuel/app/classes/insights/game/scores.php
import Segment from 'offline/insights/segment'
import Util from 'offline/util'
import Constants from 'offline/constants'

export default Segment.extend({
    name: 'scores',
    priority: 3,
    enabled: false,
    requires: ['init'],
    insight: false,
    types: [Constants.TYPE_USER],
    run: function(type, owner, userIndex, detail, filter, vars) {

        var user_id = owner.get_id()
        var playersRaw = this._data.players_raw
        var playsRaw = this._data.plays_raw

        if (!playersRaw.length) return {}

        // Build play_id => play_date lookup
        var playDates = {}
        for (var pi = 0; pi < playsRaw.length; pi++) {
            playDates[parseInt(playsRaw[pi].play_id, 10)] = parseInt(playsRaw[pi].play_date, 10) || 0
        }

        var username = owner.get_name().toLowerCase()

        // Filter to user's own player records with numeric scores
        var scores = []

        for (var i = 0; i < playersRaw.length; i++) {
            var player = playersRaw[i]

            if (!this.isSelf(player, user_id, username)) continue

            if (player.player_score === null || player.player_score === '' || player.player_score === undefined) continue

            var scoreVal = parseFloat(player.player_score)
            if (isNaN(scoreVal)) continue

            var playId = parseInt(player.play_id, 10)

            scores.push({
                score: scoreVal,
                date: playDates[playId] !== undefined ? playDates[playId] : 0
            })
        }

        if (!scores.length) return {}

        // Calculate statistics
        var values = []
        for (var vi = 0; vi < scores.length; vi++) values.push(scores[vi].score)

        var high = Math.max.apply(null, values)
        var low = Math.min.apply(null, values)
        var avg = Math.round(values.reduce(function(a, b) { return a + b }, 0) / values.length * 100) / 100

        // Distribution (rounded to integers)
        var distribution = {}
        for (var di = 0; di < values.length; di++) {
            var rounded = Math.floor(values[di])
            if (!distribution[rounded]) distribution[rounded] = 0
            distribution[rounded]++
        }

        // Trend over time (ordered by date)
        scores.sort(function(a, b) { return a.date - b.date })

        var trend = []
        for (var ti = 0; ti < scores.length; ti++) {
            trend.push({ d: scores[ti].date, s: scores[ti].score })
        }

        return {
            scores: {
                high: high,
                low: low,
                avg: avg,
                distribution: distribution,
                trend: trend
            }
        }

    }
})
